/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react'
import { AllRolesList } from '../../config/roles'
import Button from '../Button'
import { motion } from 'framer-motion'


export default function RolesSelection({ selected, handleSelection, error, handleValidation, state, setstate, checkedRoles, setCheckedRoles }) {
    const [activeAccordion, setActiveAccordion] = useState(null);

    // const toggleAccordion = (index) => {
    //     setActiveAccordion(activeAccordion === index ? null : index);
    // };
    const [openStates, setOpenStates] = useState(Array(Object.keys(AllRolesList).length).fill(false));
    // const [checkedRoles, setCheckedRoles] = useState({});
    const [selectedAll, setSelectedAll] = useState(false);
    const toggleAccordion = (index) => {
        setOpenStates(prevStates => {
            const newState = prevStates.map((state, idx) => idx === index ? !state : false);
            return newState;
        });
    };


    function compareSelected(selected) {
        // Loop through each key in AllRolesList
        for (let role in AllRolesList) {
            // If the role key from AllRolesList is not present in selected, return false
            if (!selected.hasOwnProperty(role)) {
                return false;
            }
            // Loop through each permission in the role
            for (let permission of AllRolesList[role]) {
                // If the permission key from AllRolesList is not present in selected, return false
                if (!selected[role].hasOwnProperty(permission)) {
                    return false;
                }
            }
        }
        // If all keys and permissions are present, return true
        return true;
    }
    function getKeysBefore(obj, key) {

        const keysBefore = [];
        for (const mainrole in obj) {
            const roles = obj[mainrole];
            const index = roles.indexOf(key);
            if (index > 0) {
                keysBefore.push(...roles.slice(0, index));
            }
        }
        return keysBefore;
    }

    function getKeysAfter(obj, key) {
        const keysAfter = [];
        for (const mainrole in obj) {
            const roles = obj[mainrole];
            const index = roles.indexOf(key);
            if (index >= 0 && index < roles.length - 1) {
                keysAfter.push(...roles.slice(index + 1));
            }
        }
        return keysAfter;
    }

    const handleMainCheckboxChange = (mainrole, role) => {
        if (role) {
            const isChecked = !checkedRoles[mainrole]?.[role];
            if (!isChecked) {
                let updatedCheckedRoles = { ...checkedRoles }
                const previousKeys = getKeysBefore(AllRolesList, role)
                const afterKeys = getKeysAfter(AllRolesList, role)
                if (role.includes('list')) {
                    if (role === 'merchant_list') {
                        delete updatedCheckedRoles['Manage Employee']
                        delete updatedCheckedRoles['Manage Stores']
                    }
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role === 'change_support_ticket_status' || role === 'change_settlement_status') {
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role === 'view_support_request' || role === 'view_settlement') {
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role === 'view_merchant') {
                    delete updatedCheckedRoles['Manage Employee']
                    delete updatedCheckedRoles['Manage Stores']
                    delete updatedCheckedRoles[mainrole]['update_merchant']
                }
                if (role.includes('activate_or_deactivate') || role.includes('change_store_customization')) {
                    
                    // if (afterKeys.length > 0) {
                    //     afterKeys.map((key,i) => {
                    //         delete updatedCheckedRoles[mainrole][key];
                    //     })
                    // }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                // const afterKeys = getKeysAfter(AllRolesList, role)
                if (previousKeys.length > 0 && afterKeys.length === 0) {
                    previousKeys.map((key, i) => {
                        delete updatedCheckedRoles[mainrole][key];
                    })
                }
                delete updatedCheckedRoles[mainrole][role]
                if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                    delete updatedCheckedRoles[mainrole];
                }
                setCheckedRoles({ ...updatedCheckedRoles })
                return;
            }
            let updatedCheckedRoles = { ...checkedRoles };
            const previousKeys = getKeysBefore(AllRolesList, role)
            if (!updatedCheckedRoles[mainrole]) {
                updatedCheckedRoles[mainrole] = {};
            }
            switch(role){
                
            case 'change_store_customization':  updatedCheckedRoles[mainrole]['store_list'] = isChecked;
                updatedCheckedRoles[mainrole]['update_store'] = isChecked;
                break;
            case 'send_email':  updatedCheckedRoles[mainrole]['merchant_list'] = isChecked;
                break;
            }
            if (previousKeys.length > 0) {
                if (mainrole !== "Other Privileges" && role !=='change_store_customization' && role !=='send_email') {
                    previousKeys.forEach((key) => {
                        updatedCheckedRoles[mainrole][key] = isChecked;
                    });
                }
            }
            if (mainrole === 'Manage Employee' || mainrole === 'Manage Stores') {

                if (!(updatedCheckedRoles['Manage Merchants']?.merchant_list && updatedCheckedRoles['Manage Merchants']?.view_merchant)) {
                    updatedCheckedRoles['Manage Merchants'] = {
                        'merchant_list': true,
                        'view_merchant': true
                    };
                }
            }
            updatedCheckedRoles[mainrole][role] = isChecked;

            setCheckedRoles({ ...checkedRoles, ...updatedCheckedRoles });
            return;
        }


        const isChecked = !checkedRoles[mainrole];
        if (!isChecked) {
            let updatedCheckedRoles = { ...checkedRoles }
            if (mainrole === 'Manage Merchants') {
                delete updatedCheckedRoles['Manage Employee'];
                delete updatedCheckedRoles['Manage Stores'];
            }
            delete updatedCheckedRoles[mainrole];
            setCheckedRoles({ ...updatedCheckedRoles });
            return
        }
        const updatedSubRoles = { [mainrole]: {} };
        if (mainrole === 'Manage Employee' || mainrole === 'Manage Stores') {
            if (!(checkedRoles['Manage Merchants']?.merchant_list && checkedRoles['Manage Merchants']?.view_merchant)) {
                updatedSubRoles['Manage Merchants'] = {
                    'merchant_list': true,
                    'view_merchant': true
                };
            }

        }
        AllRolesList[mainrole].forEach(subrole => {
            updatedSubRoles[mainrole][subrole] = isChecked;
        });
        setCheckedRoles({ ...checkedRoles, ...updatedSubRoles });
    };
    const handleSelecAll = () => {
        if (selectedAll) {
            setSelectedAll(false)
            setCheckedRoles({});
        } else {
            const resultDict = {};
            for (const role in AllRolesList) {
                const roleDict = {};
                AllRolesList[role].forEach(permission => {
                    roleDict[permission] = true;
                });
                resultDict[role] = roleDict;
            }
            setSelectedAll(true)
            setCheckedRoles({ ...resultDict });
        }

    }

    function objectToArray(rolesObject) {
        let trueSubRoles = []
        for (const mainRole in rolesObject) {
            if (Object.prototype.hasOwnProperty.call(rolesObject, mainRole)) {
                const subRoles = Object.keys(rolesObject[mainRole]).filter(subRole => rolesObject[mainRole][subRole]);
                trueSubRoles.push(...subRoles);
            }
        }

        return trueSubRoles
    }

    useEffect(() => {
        let arr = objectToArray(checkedRoles)
        setstate(prevState => ({
            ...prevState, // Spread previous state
            admin_privileges: arr // Update or add the new key-value pair
        }));
        if (!compareSelected(checkedRoles)) {
            setSelectedAll(false)
        } else {
            setSelectedAll(true);
        }
    }, [checkedRoles])

    function stringConverter(inputString) {
        const words = inputString.split('_');
        const result = words.map(word => {
            if (word.toLowerCase() === 'or') {
                return word.toLowerCase();
            } else {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
        });
        return result.join(' ');
    }


    return (
        <>
            <div className="px-[17px] w-[100%] relative py-4">
                <div className=" custom-checkbox1 relative flex items-center ">
                    <input
                        type="checkbox"
                        className="w-4 cursor-pointer border border-[#9E2064]"
                        id={`select-all`}
                        data-testid={`select-all`}
                        checked={selectedAll}
                        onClick={() => handleSelecAll()}
                        name='checkbox' />
                    <label
                        className="text-[#1F1F1F]  pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                        htmlFor={`select-all`}>
                        Select All
                    </label>
                </div>
            </div>
            <div data-testid='privilege-div' className="flex flex-wrap mb-6 -mx-[24px] relative">
                {Object.keys(AllRolesList).map((mainrole, mainIndex) => (
                    <div className="accordion max-w-[32.733333%] basis-[32.733333%] relative h-[58px] px-[24px]" key={mainrole}>
                        <div className={`border border-[#DDDDDD] w-full rounded-[4px] absolute bg-white`} style={{ width: "-webkit-fill-available", zIndex: 40 - (mainIndex + 1) }}>
                            <div className={`py-4 px-4 border-[#DDDDDD] bg-white`} style={{ width: "-webkit-fill-available", backgroundColor: 'white' }}>
                                <div className='flex justify-between items-center'>
                                    <div className="custom-checkbox1 relative flex items-center">
                                        <input
                                            type="checkbox"
                                            className="w-4 cursor-pointer border border-[#9E2064]"
                                            id={`main-checkbox-${mainIndex}`}
                                            data-testid={`main-checkbox-${mainIndex}`}
                                            checked={checkedRoles[mainrole] || false}
                                            onChange={() => {
                                                // toggleAccordion(mainIndex);
                                                handleMainCheckboxChange(mainrole);
                                            }}
                                            name='checkbox' />
                                        <label
                                            className="text-[#1F1F1F]  pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                                            onChange={() => {
                                                // toggleAccordion(mainIndex);
                                                handleMainCheckboxChange(mainrole);
                                            }}
                                            htmlFor={`main-checkbox-${mainIndex}`}>
                                            {mainrole}
                                        </label>

                                    </div>
                                    <span style={{ float: 'right', cursor: 'pointer' }} data-testid={`dropdown-${mainIndex}`} onClick={() => toggleAccordion(mainIndex)}>
                                        <img src={`/assets/images/accordion-${openStates[mainIndex]}.svg`} alt="" />

                                    </span>
                                </div>
                                <div className={`accordion-main bg-white w-full ${openStates[mainIndex] && 'border-t border-[#DDDDDD] mt-5'}`}>
                                    {openStates[mainIndex] &&

                                        (AllRolesList[mainrole].map((role, i) => (
                                            <div
                                                className={`accordion-content py-4 pl-4 relative  bg-white`}
                                                key={role}
                                            >
                                                <div className=" custom-checkbox1 relative flex items-center ">
                                                    <input
                                                        type="checkbox"
                                                        className="w-4 cursor-pointer border border-[#9E2064]"
                                                        id={`sub-checkbox-${mainrole}-${i}`}
                                                        data-testid={`sub-checkbox-${mainIndex}-${i}`}
                                                        checked={checkedRoles?.[mainrole]?.[role] || false}
                                                        onClick={() => handleMainCheckboxChange(mainrole, role)}
                                                        name='checkbox' />
                                                    <label
                                                        className="text-[#1F1F1F]  pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                                                        htmlFor={`sub-checkbox-${mainrole}-${i}`}>
                                                        {/* {role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} */}
                                                        {/* {
                                                            (role === 'change_settlement_status' || role === 'change_support_ticket_status') ?
                                                                'Change Status'
                                                                :
                                                                role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
                                                        } */}
                                                        {(role => {
                                                            if (role === 'change_settlement_status' || role === 'change_support_ticket_status')  {
                                                                return 'Change Status';
                                                            } else if (role.includes('activate_or_deactivate')) {
                                                                return stringConverter(role)
                                                            } else {
                                                                return role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                                                            }
                                                        })(role)}
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                        )
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
            </div >
        </>
    )
}
